import { render, staticRenderFns } from "./CopySelectedTrade.vue?vue&type=template&id=50802f8a&"
import script from "./CopySelectedTrade.vue?vue&type=script&lang=js&"
export * from "./CopySelectedTrade.vue?vue&type=script&lang=js&"
import style0 from "./CopySelectedTrade.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CopySelectedTrade.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../front.sfc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports